import React from "react";

interface TextFilledIconProps {
  className?: string;
}

const TextFilledIcon: React.FC<TextFilledIconProps> = ({ className }) => (
  <svg enableBackground="new 0 0 512 512" viewBox="0 0 512 512">
    <g>
      <circle cx="45.322" cy="45.322" r="45.322" />
      <circle cx="45.322" cy="466.678" r="45.322" />
      <circle cx="466.678" cy="466.678" r="45.322" />
      <path d="m45.322 391.355c7.08 0 13.927 1.003 20.428 2.838v-276.387c-6.501 1.835-13.347 2.838-20.428 2.838-3.245 0-6.435-.229-9.572-.629v271.97c3.138-.4 6.328-.63 9.572-.63z" />
      <path d="m120.015 35.75c.4 3.138.629 6.328.629 9.572 0 7.08-1.003 13.927-2.838 20.428h276.387c-1.835-6.501-2.838-13.347-2.838-20.428 0-3.245.229-6.435.629-9.572z" />
      <path d="m466.678 120.645c-7.08 0-13.927-1.003-20.428-2.838v276.387c6.501-1.835 13.347-2.838 20.428-2.838 3.245 0 6.435.229 9.572.629v-271.97c-3.138.4-6.328.63-9.572.63z" />
      <circle cx="466.678" cy="45.322" r="45.322" />
      <path d="m391.985 476.25c-.4-3.138-.629-6.328-.629-9.572 0-7.08 1.003-13.927 2.838-20.428h-276.388c1.835 6.501 2.838 13.347 2.838 20.428 0 3.245-.229 6.435-.629 9.572z" />
      <path d="m416.667 410.42v-308.84c-2.202-1.96-4.287-4.045-6.247-6.247h-308.84c-1.96 2.202-4.045 4.287-6.247 6.247v308.84c2.202 1.96 4.287 4.045 6.247 6.247h308.84c1.959-2.202 4.045-4.288 6.247-6.247zm-69.717-213.292v-25.128h-75.95v170.849h25.996v30h-81.992v-30h25.996v-170.849h-75.95v25.128h-30v-55.128h241.9v55.128z" />
    </g>
  </svg>
);

export default TextFilledIcon;
